<template>
    <router-link :to="{name:href}" class="guang" :style="{'--bg-color':bgColor}">
        <label style="height: 100%;width: 100%;display: flex;justify-content: center;align-items: center;">{{title}}</label>
    </router-link>

</template>

<script>

export default {
    name: 'MyButtonMobile',
    components: {
    },
    props: ['title','href','bgColor']
}
</script>

<style lang="less" scoped>


.guang {
    position: relative;
    display: inline-block;
    width: 170px;
    height: 100px;
    color: rgb(255, 255, 255);
    line-height: 80px;
    font-size: 20pt;
    font-family: sans-serif;
    text-decoration: none;
    text-transform: uppercase;
    text-align: center;
    border-radius: 20px;
    background: var(--bg-color);
    background-size: 500%;
    z-index: 1;
    text-shadow: 0 0 5px white,
        0 0 5px white;
}

.guang:hover {
    animation: move 5s linear alternate infinite;
}

@keyframes move {
    0% {
        background-position: 0%;
    }

    100% {
        background-position: 100%;
    }
}

.guang::before {
    content: '';
    position: absolute;
    top: -10px;
    left: -10px;
    width: 190px;
    height: 120px;
    background: var(--bg-color);
    background-size: 500%;
    opacity: 0;
    z-index: -1;
    border-radius: 45px;
    transition: 0.6s;

}

.guang:hover::before {
    filter: blur(15px);
    opacity: 1;
    animation: move 8s linear alternate infinite;
}
</style>